import { useEffect, useRef, useState } from "react";

import { Secret } from "../models/secret";
import { getSecretManager } from "../util/getSecretManager";

export const useSecretManager = (secretId?: string) => {
  const [secret, setSecret] = useState<Secret | null>();
  const [isLoading, setIsLoading] = useState<boolean>(!!secretId);

  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (secretId) updateSecretManager(secretId);
  }, [secretId]);

  const updateSecretManager = async (id: string) => {
    setIsLoading(true);
    const secretFound: Secret | null = await getSecretManager(id);

    if (isMounted.current) {
      setSecret(secretFound);
      setIsLoading(false);
    }
  };

  return { secret: secret ?? undefined, isLoading };
};
